import { AppInsights } from "applicationinsights-js";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { trackException as appInsightsTrackException } from "@teamprevent/common/logging/appInsightsSetup";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { getProperties } from "./getProperties";

export const trackException = (e: Error, severityLevel: SeverityLevel) => {
    const useAppInsightsConnectionString = getFeatureToggles()[FeatureToggleNames.UseAppInsightsConnectionString];
    if (!useAppInsightsConnectionString) {
        AppInsights.trackException(e);
    } else {
        appInsightsTrackException({ exception: e, severityLevel }, getProperties());
    }
};
